<script setup lang="ts">
import { RouterWrapper } from '@bagelink/vue'
</script>

<template>
	<a class="skip-link fixed top-05 start-05 z-99 py-075 px-1 bg-white" href="#main-content">Skip to content</a>
	<main id="main-content">
		<RouterWrapper />
	</main>
</template>
